// src/pricer/services/usePricerNetworkDiscovery.js
import { useState, useCallback } from 'react'

const getLocalIpViaWebRTC = () =>
  new Promise((resolve) => {
    try {
      const pc = new RTCPeerConnection({ iceServers: [] })
      pc.createDataChannel('')
      const timeoutId = setTimeout(() => resolve(null), 3000)
      pc.onicecandidate = (ice) => {
        if (!ice?.candidate?.candidate) return
        const match = ice.candidate.candidate.match(/(\d+\.\d+\.\d+)\.\d+/)
        if (match) {
          clearTimeout(timeoutId)
          pc.onicecandidate = null
          pc.close()
          resolve(match[1])
        }
      }
      pc.createOffer().then(
        (offer) => pc.setLocalDescription(offer)
      )
    } catch (error) {
      resolve(null)
    }
  })

const getLocalSubnet = async () => {
  let subnet = await getLocalIpViaWebRTC()
  if (!subnet && window.Android?.getNetworkInfo) {
    try {
      const info = JSON.parse(window.Android.getNetworkInfo())
      const match = info.ip?.match(/(\d+\.\d+\.\d+)\.\d+/)
      if (match) subnet = match[1]
    } catch {}
  }
  return subnet
}

const tryAddress = async (ip, port) => {
  try {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 1000)
    await fetch(`http://${ip}:${port}`, { method: 'HEAD', signal: controller.signal })
    clearTimeout(timeout)
    return ip
  } catch {
    return null
  }
}

const usePricerNetworkDiscovery = () => {
  const [isSearching, setIsSearching] = useState(false)

  const discover = useCallback(async (port, onFound) => {
    setIsSearching(true)
    try {
      const subnet = await getLocalSubnet()
      if (!subnet) {
        onFound(null)
        return
      }
      for (const ip of [`${subnet}.23`, `${subnet}.212`]) {
        const found = await tryAddress(ip, port)
        if (found) {
          onFound(found)
          return
        }
      }
      onFound(null)
    } finally {
      setIsSearching(false)
    }
  }, [])

  return { isSearching, discover }
}

export { usePricerNetworkDiscovery, getLocalSubnet, tryAddress }
